export default "__VITE_ASSET__C0n5Veh6__"